import React, { useState, useEffect } from "react";

import Design from "./Design";
import { fetchTargets, RoleEvent } from "../../services/benefitApi";
import { CpTopRank, CpTopRankAllEvents } from "../../services/cp";
const Benefit = () => {
  const [CpTopRan, setCpTopRank] = useState(null);
  const [AllEvents, setAllEvents] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const data1 = await CpTopRank();
        setCpTopRank(data1.data);
        const data2 = await CpTopRankAllEvents();
        setAllEvents(data2.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Design CpTopRan={CpTopRan} AllEvents={AllEvents} />
    </div>
  );
};

export default Benefit;
